@if (state.initialized && state.question) {
  <as-split
    @appearDisappear
    [direction]="'horizontal'"
    unit="pixel"
    class="h-full"
    [gutterSize]="1"
    [useTransition]="true"
  >
    <as-split-area [size]="'*'" [minSize]="200">
      <exam-detail-view-wrapper>
        <ng-container title>
          <div class="flex items-center justify-between pl-4 pr-1">
            <div class="flex items-center gap-2">
              <span> Question #{{ state.question.id }} </span>
            </div>
            <div class="flex items-center gap-2">
              @if (state.referenceQuestion) {
                <dojo-button
                  [size]="'xs'"
                  [fill]="'outline'"
                  [customColor]="'indigo'"
                  dojoReferenceQuestionPopupTrigger
                  [referenceQuestion]="state.referenceQuestion"
                  [markCalculationMethod]="state.markCalculationMethod"
                >
                  Ref. question
                </dojo-button>
              }

              <dojo-button
                [size]="'xs'"
                [fill]="'outline'"
                [customColor]="'sky'"
                (click)="createSeedQuestion()"
                [matTooltip]="'Create seed'"
                class="ml-auto"
                [pending]="isCreatingSeedQuestion()"
              >
                Create seed
              </dojo-button>
              <dojo-button
                [size]="'xs'"
                [fill]="'outline'"
                [customColor]="'sky'"
                [disabled]="!state.canUndo"
                (click)="undo()"
                [matTooltip]="'Undo'"
                class="ml-auto"
              >
                <dojo-icon icon="undo" />
              </dojo-button>
              <dojo-button
                [size]="'xs'"
                [fill]="'outline'"
                [customColor]="'sky'"
                [disabled]="!state.canRedo"
                (click)="redo()"
                [matTooltip]="'Redo'"
              >
                <dojo-icon icon="redo" />
              </dojo-button>
              <dojo-button [size]="'xs'" [fill]="'outline'" [customColor]="'sky'" dojoJsonEditorTrigger>
                JSON
              </dojo-button>
              <dojo-new-question-item-button />
              <dojo-button
                [size]="'xs'"
                [customColor]="'sky'"
                [disabled]="questionItemsForm.pristine && (!isSeedQuestion() || !feedbackFormState()?.canSubmit)"
                [pending]="isSaving()"
                (click)="saveQuestionItems()"
              >
                <div class="flex items-center gap-1.5">
                  <dojo-icon [icon]="'save'" />
                  <span>Save</span>
                </div>
              </dojo-button>
            </div>
          </div>
        </ng-container>

        <div class="flex h-full flex-col">
          <div class="scrollbar-gutter-stable flex-1 overflow-y-auto overflow-x-hidden pl-2">
            <dojo-question-items-editor
              [calculatorAllowed]="state.calculatorAllowed"
              [markCalculationMethod]="state.markCalculationMethod"
            />
          </div>
        </div>
        <ng-container sidebar>
          @if (isSeedQuestion()) {
            <mat-button-toggle-group
              class="custom-toggle-group size-s"
              hideSingleSelectionIndicator
              [value]="sidebarTab()"
              (change)="sidebarTab.set($event.value)"
            >
              <mat-button-toggle [value]="'details'">Details</mat-button-toggle>
              <mat-button-toggle [value]="'feedback'">Feedback</mat-button-toggle>
            </mat-button-toggle-group>
          }

          <a
            class="flex items-center gap-1 text-sm font-semibold text-sky-500 underline hover:text-sky-600"
            (click)="openHistoryDialog()"
          >
            <dojo-icon [icon]="'timeline'" />
            <span>Open history</span>
          </a>

          @if (sidebarTab() === 'details') {
            <div class="flex flex-col gap-4">
              <dojo-question-status-selector [formCtrl]="statusCtrl" [label]="'Status'" [size]="'s'" />

              <div class="custom-mat-form-wrapper">
                <div class="mat-form-label">
                  <span>Reference Question</span>
                </div>

                <a
                  [routerLink]="[
                    '/',
                    CmsUrlParts.Syllabus,
                    state.activeSyllabus?.slug,
                    CmsUrlParts.ReferenceQuestions,
                    state.referenceQuestion?.id
                  ]"
                  class="text-sm font-semibold text-sky-500 underline hover:text-sky-600"
                >
                  {{ state.referenceQuestion?.id }}
                </a>
              </div>
            </div>
          } @else if (sidebarTab() === 'feedback' && isSeedQuestion()) {
            <div class="flex flex-1 flex-col gap-4">
              <div class="scrollbar-gutter-stable flex-1 overflow-y-auto">
                <dojo-consensus-feedback-form
                  [activeReviewMode]="DerivativeQuestionReviewType.HumanReview"
                  [calculatorAllowed]="state.calculatorAllowed"
                  [checklistConfig]="dynamicSurveyConfig()"
                  [editingAllowed]="true"
                  [showFixedToggle]="false"
                  [markschemeInfo]="markschemeInfo()"
                  [feedback]="state.question.question.metadata?.seed?.expected_feedback"
                  (formStateChange)="feedbackFormState.set($event)"
                  #feedbackFormComponent
                />
              </div>
            </div>
          }
        </ng-container>
      </exam-detail-view-wrapper>
    </as-split-area>

    <as-split-area
      class="flex h-full flex-col !overflow-y-hidden"
      [minSize]="280"
      [maxSize]="900"
      [size]="400"
      [visible]="this.activeQuestionItem()"
    >
      <dojo-question-active-item-editor />
    </as-split-area>
  </as-split>
} @else if (state.isLoading) {
  <!-- Loading... -->
} @else {
  Given question does not exist.
}
